import React from 'react';
import {Radio} from 'antd';
import {PaperLayout} from "../../components/styled/PaperLayout";
import TitleHeader from "../../components/view/TitleHeader";
import {faFilter, faUserCog} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {HorizontalLayout} from "../../layout/HorizontalLayout";
import Field from "../../components/Field";
import {ParsedUrlQuery} from "querystring";
import {queryParams} from "../../utils/index";
import {useHistory, useLocation} from "react-router";
import {REQUESTS_REDIRECT} from "../../components/ReservedSwitcher";
import './AdminForm.css';

interface AdminFormInterface {}

const stringValue = (arg : string | string[]): string => {
    return (Array.isArray(arg) ? arg[0]: arg);
};

const options = [
    { label: 'In Lavorazione', value: 'pending' },
    { label: 'Approvate', value: 'approved' },
    { label: 'Respinte', value: 'rejected' },
];


const AdminForm: React.FC<AdminFormInterface> = (props) => {
    const location = useLocation();
    const queryMap: ParsedUrlQuery = queryParams(location.search);
    const statusValue = stringValue(queryMap['status']);
    const [status, setStatus] = React.useState(undefined as (undefined | string))
    const history = useHistory();

    React.useEffect(()=> {

        if (statusValue !== undefined) {

            setStatus(statusValue);
        }

    }, [statusValue]);

    return (
        <PaperLayout asCard={true}>
            <TitleHeader
                marginBottom={'5px'}
                fontSize={'1.2rem'}
                title={'Richieste Modifica Consenso'}
                color={'green'} icon={<FontAwesomeIcon icon={faFilter}/>}/>
            <HorizontalLayout>
                <Field
                    fontSize={'0.9rem'}
                    label={'Stato della Richiesta'}
                >
                 <Radio.Group
                     optionType="button"
                     options={options}
                     value={status}
                     className={'sergen'}
                     onChange={e => {
                         history.push(`${REQUESTS_REDIRECT}?status=${e.target.value}`);
                         //setStatus(e.target.value)
                     }}
                 />
                </Field>
            </HorizontalLayout>
        </PaperLayout>
    )
};

export default AdminForm;